import { LoadableAfterPaint } from '@confluence/loadable';

export const ExcerptExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExcerptExtensionHandler" */ '../src/ExcerptExtensionHandler.tsx'
			)
		).ExcerptExtensionHandler,
});
